import React from 'react';
import { Background } from '@kite-js/system';
import { Box, BoxProps } from '@drone-js/core';

interface Props extends BoxProps {
    noBackground?: boolean;
    background?: Background;
    style?: React.CSSProperties;
}

const PageContainer: React.FC<React.PropsWithChildren<Props>> = (props) => {
    return (
        <Box backgroundColor={props.noBackground ? undefined : 'base.background'} overflowY="auto" {...props}>
            {props.children}
        </Box>
    );
};
PageContainer.displayName = 'PageContainer';

export default PageContainer;
